import { Fragment } from "react";
import { Link } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export const Split = ({ as: Tag = "h2", className = "", text, serif, ...rest }) => {
  let i = 0;
  const words = (s) => s.split(/\s+/).filter(Boolean).map((w, k) => (
    <Fragment key={k}><span className="w"><span style={{ "--i": i++ }}>{w}</span></span>{" "}</Fragment>
  ));
  return (
    <Tag className={`split ${className}`} {...rest}>
      {words(text)}
      {serif && <span className="serif">{words(serif)}</span>}
    </Tag>
  );
};

export const Brand = ({ to = "/" }) => (
  <Link to={to} className="brand" data-testid="logo-link" aria-label="Heartmony">
    <img src="/logo-heartmony.png?v=2" alt="Heartmony" className="logo-l" />
    <img src="/logo-heartmony-dark.png?v=1" alt="Heartmony" className="logo-d" />
  </Link>
);

export const ThemeToggle = () => {
  const { theme, toggle } = useTheme();
  return (
    <button className="icon-btn" onClick={toggle} data-testid="theme-toggle"
      aria-label={theme === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}>
      {theme === "dark" ? <Sun /> : <Moon />}
    </button>
  );
};

export const Dawn = ({ style }) => (
  <div className="dawn" aria-hidden="true" style={style}><i /><i /><i /><i /></div>
);

export const Arrow = () => (
  <svg className="arr" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
);

export const Skeleton = ({ h = 88, n = 3 }) => (
  <div className="grid gap-3" data-testid="loading-skeleton">
    {Array.from({ length: n }).map((_, i) => <div key={i} className="sk" style={{ height: h }} />)}
  </div>
);

export const PageHead = ({ eyebrow, title, serif, lead }) => (
  <div className="page-head">
    <span className="eyebrow">{eyebrow}</span>
    <Split as="h1" className="hm-h1" text={title} serif={serif} />
    {lead && <p className="lead rv">{lead}</p>}
  </div>
);
